import { defineFrontendModule } from '~/lib/module';

defineFrontendModule({
  name: 'docs',
  owner: 'cella',
  scope: ['frontend'],
  description: 'Public documentation UI: MDX pages plus the generated API reference.',
});
